import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=5b9177ff&scoped=true&"
import script from "./Pill.vue?vue&type=script&lang=js&"
export * from "./Pill.vue?vue&type=script&lang=js&"
import style0 from "./Pill.vue?vue&type=style&index=0&id=5b9177ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9177ff",
  null
  
)

export default component.exports